import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { headersForSwitchDeposit } from './listOfTabs'
import MediaQuery from 'react-responsive'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import AutosizeInput from 'react-input-autosize'
import Accounting from 'accounting'
import { numberWithCommas } from '../../fiches';
import CommonFetch from '../../requests/commonFetch'

export default class SwitchDeposit extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tabState: {
                openBlockId: 0,
                deposit_from_my_wallet: true,
                deposit_from_another_depository: false,
                withdraw_to_my_wallet: false,
                send_to_another_depository: false,
                // buy_CPT: false,
            },
            copied: false,
            textCopyBtn: 'Copy',
            value: '',
            correctedString: '',
            modal: false,
            modalForm: '',
            dataForm: '',
            errorMessage: 'operation failed',
            successMessage: 'operation completed successfully',
            activeError: false,
            activeSuccess: false,
            timeout: 2000,
            withdrawError: false,
            twofaType: false,
            twofaText: '',
        }

        this.translation = JSON.parse(localStorage.translation)[localStorage.language];

        this.postDeposit = this.postDeposit.bind(this);
        this.postWithDraw = this.postWithDraw.bind(this);
        this.postPay = this.postPay.bind(this);

        this.modalForm = {
            "deposit": this.postDeposit,
            "withdraw": this.postWithDraw,
            "pay": this.postPay
        }

        this.twoFAText = {
            'none': '',
            'email': 'sent to Email',
            'sms': 'sent by SMS',
            'ga': 'from the Google Authenticator app',
        }
    }

    componentDidMount() {
        this.checkTwoFAType();
    }

    checkTwoFAType = () => {
        CommonFetch({
            path: 'ui/investor_settings/get_userdata',
            method: 'GET',
        }).then(data => {
            if (data['2fa_type'] !== 'none') {
                this.setState({
                    twofaType: true,
                    twofaText: this.translation[this.twoFAText[data['2fa_type']]],
                })
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            }
        })
    }


    getStatus = () => {
        if (this.state.twofaType) {
            CommonFetch({
                path: 'ui/get_status',
                method: 'GET',
            }).then(data => {
                if (data.error === 'not_logged_in') {
                    this.props.exitOverdueSession()
                } else if (data['2fa_code_request_required']) {
                    this.get2FACode()
                } else if (!data['2fa_code_request_required']) {
                    this.setState({
                        modal: true,
                    })
                }
            })

        } else {
            this.setState({
                activeError: true,
                errorMessage: 'need to configure two-factor authentication',
            })
            this.messageClose();
        }
    }

    postDeposit = event => {
        event.preventDefault()

        let btnSubmit = event.target.querySelector('input[type=submit]')
        let dataForm = this.state.dataForm
        btnSubmit.setAttribute('disabled', 'true')
        dataForm.append(
            '2fa_code',
            event.target.querySelector('input[type=text]').value
        )

        CommonFetch({
            path: 'ui/depository/post_deposit',
            method: 'POST',
            data: dataForm,
        }).then(data => {
            if (data.success) {
                this.modalClose()
                this.setState({
                    activeSuccess: true,
                })
                this.messageClose()
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            } else {
                this.setState({
                    activeError: true,
                    errorMessage: 'operation failed',
                })
                this.messageClose()
            }
            btnSubmit.setAttribute('disabled', 'false')
        })
    }


    postWithDraw = event => {
        event.preventDefault()

        let btnSubmit = event.target.querySelector('input[type=submit]')
        let dataForm = this.state.dataForm
        btnSubmit.setAttribute('disabled', 'true')
        dataForm.append(
            '2fa_code',
            event.target.querySelector('input[type=text]').value
        )

        CommonFetch({
            path: 'ui/depository/post_withdraw',
            method: 'POST',
            data: dataForm,
        }).then(data => {
            if (data.success) {
                this.modalClose()
                this.setState({
                    activeSuccess: true,
                })
                this.messageClose()
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            } else {
                this.setState({
                    activeError: true,
                    errorMessage: 'operation failed',
                })
                this.messageClose()
            }
            btnSubmit.setAttribute('disabled', 'false')
        })
    }


    postPay = event => {
        event.preventDefault()

        let btnSubmit = event.target.querySelector('input[type=submit]')
        let dataForm = this.state.dataForm
        btnSubmit.setAttribute('disabled', 'true')
        dataForm.append(
            '2fa_code',
            event.target.querySelector('input[type=text]').value
        )

        CommonFetch({
            path: 'ui/depository/post_pay',
            method: 'POST',
            data: dataForm,
        }).then(data => {
            if (data.success) {
                this.modalClose()
                this.setState({
                    activeSuccess: true,
                })
                this.messageClose()
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            } else {
                this.setState({
                    activeError: true,
                    errorMessage: 'operation failed',
                })
                this.messageClose()
            }
            btnSubmit.setAttribute('disabled', 'false')
        })
    }


    get2FACode = () => {
        CommonFetch({
            path: 'ui/auth/post_request2facode',
            method: 'POST',
        }).then(data => {
            if (data.success || data.type === 'ga') {
                this.setState({
                    modal: true,
                })
            } else if (data.error === 'not_logged_in') {
                this.props.exitOverdueSession()
            }
        })
    }



    modalView = () => {
        return (
            <div className="modal">
                <div className="background" onClick={this.modalClose} ></div>
                <div className="modal-content">
                    <form onSubmit={this.state.modalForm}>
                        <h4>{this.translation['Enter two-factor']}{this.state.twofaText}</h4>
                        <input name="2fa_code" type="text" />
                        <input type="submit" className="btn btn-submit" value={this.translation["Send"]} />
                    </form>
                </div>
            </div>
        )
    }

    errorMessageView = () => {
        return (
            <div className={`error_message ${this.state.activeError ? 'active' : ''}`}>
                <p>{this.translation[this.state.errorMessage]}</p>
            </div>
        )
    }

    successMessageView = () => {
        return (
            <div className={`success_message ${this.state.activeSuccess ? 'active' : ''}`}>
                <p>{this.translation[this.state.successMessage]}</p>
            </div>
        )
    }

    modalClose = () => {
        this.setState({
            modal: false,
            dataForm: '',
        })
    }

    messageClose = () => {
        setTimeout(() => this.setState({
            activeError: false,
            activeSuccess: false,
        }), this.state.timeout);
    }

    checkTransactionValue = event => {
        let value = event.target.value,
            form = document.querySelector('.withdraw_to_my_wallet_form'),
            button = form.querySelector('.btn');

        if (+this.props.data.balanceDepository < (+value) + (+this.props.data.freeWithdrawCpt)) {
            this.setState({
                withdrawError: true,
            });
            button.disabled = true;
        } else {
            this.setState({
                withdrawError: false,
            });
            button.disabled = false;
        }
    }

    copyAddress = () => {
        this.setState({
            copied: true,
            textCopyBtn: 'Copied',
        })
        setTimeout(() => this.setState({ textCopyBtn: 'Copy' }), 1000)
    }

    render() {
        let classContainerRight = ['switchDepository_container_right']

        const headersSwitchDeposit = headersForSwitchDeposit.map((item, i) => {
            let classTab = ['switchDepository_container_left_tab']
            let classTabTitle = ['']
            let classTabIcon = ['']
            let classTabBottom = ['tab_background_color_replacement_bottom']

            if (this.state.tabState.openBlockId === i) {
                classTab.push('tab_background_color_replacement')
                classTabTitle.push('tab_text_color_replacement')
                classTabIcon.push('tab_icon_hidden')
                classContainerRight.push(`${item.short_title}`)
                classTabBottom.push(`${item.short_title}`)
            }

            return (
                <MediaQuery key={i} query="(min-width: 50em)">
                    {matches => {
                        return matches ? (
                            <div
                                key={i}
                                className={classTab.join(' ')}
                                onClick={() => {
                                    this.switchTab(item.short_title, i)
                                }}
                            >
                                <p className={classTabTitle.join(' ')}>
                                    {this.translation[item.title]}
                                </p>
                                <FontAwesomeIcon
                                    className={classTabIcon.join(' ')}
                                    icon={'angle-right'}
                                />
                            </div>
                        ) : (
                            <div
                                key={i}
                                className={classTab.join(' ')}
                                onClick={() => {
                                    this.switchTab(item.short_title, i)
                                }}
                            >
                                <div className="tab_background_color_replacement_top">
                                    <p className={classTabTitle.join(' ')}>
                                        {this.translation[item.title]}
                                    </p>
                                </div>
                                <div
                                    className={
                                        this.state.tabState.openBlockId === i
                                            ? 'tab_background_color_replacement_bottom'
                                            : ''
                                    }
                                >
                                    {this.depositFromMyWallet(item.short_title)}
                                    {this.depositFromAnotherDepository(
                                        item.short_title
                                    )}
                                    {this.withdrawToMyWallet(item.short_title)}
                                    {this.sendToAnotherDepository(
                                        item.short_title
                                    )}
                                    {/*{this.buyCPT(item.short_title)}*/}
                                </div>
                            </div>
                        )
                    }}
                </MediaQuery>
            )
        })

        return (
            <div className="switchDepository">
                <div className="switchDepository_container">
                    <div className="switchDepository_container_left">
                        {headersSwitchDeposit}
                    </div>
                    <div className="switchDepository_container_right">
                        {this.depositFromMyWallet('deposit_from_my_wallet')}
                        {this.depositFromAnotherDepository(
                            'deposit_from_another_depository'
                        )}
                        {this.withdrawToMyWallet('withdraw_to_my_wallet')}
                        {this.sendToAnotherDepository(
                            'send_to_another_depository'
                        )}
                        {/*{this.buyCPT('buy_CPT')}*/}
                    </div>
                </div>
                {this.state.modal ? this.modalView() : ''}
                {this.errorMessageView()}
                {this.successMessageView()}
            </div>
        )
    }

    switchTab = (tabShortTitle, tabKey) => {
        if (tabKey === this.state.tabState.openBlockId) return null

        let tabState = Object.assign({}, this.state.tabState)

        for (let item in tabState) {
            if (item === tabShortTitle) {
                tabState[tabShortTitle] = true
            } else if (item === 'openBlockId') {
                tabState.openBlockId = tabKey
            } else {
                tabState[item] = false
            }
        }

        this.setState({ tabState })
    }

    depositFromMyWallet = item => {
        if (
            !this.state.tabState.deposit_from_my_wallet ||
            item !== 'deposit_from_my_wallet'
        )
            return null

        return (
            <div className="deposit_from_my_wallet">
                <form
                    className="deposit_from_my_wallet_form"
                    onSubmit={this.formSubmit}
                    data-active-form="deposit"
                >
                    <div className="deposit_from_my_wallet_form_transfer_amount">
                        <input
                            type="text"
                            placeholder="0,0"
                            required
                            name="amount"
                            value={this.state.value}
                            onChange={this.handleChange}
                        />
                        <p>cpt</p>
                    </div>
                    <div className="deposit_from_my_wallet_form_total_score">
                        <p>{this.translation['Maximum amount available for deposit']}: {numberWithCommas(this.props.data.balanceWalletCpt)} cpt</p>
                    </div>
                    <div className="deposit_from_my_wallet_form_info_transaction">
                        <div>
                            <p>{this.translation['The cost per transaction']} {numberWithCommas(this.props.data.freeDepositEth)} ETH</p>
                            <p>{this.translation['Is in your wallet']} {numberWithCommas(this.props.data.balanceWalletEth)} ETH</p>
                        </div>
                        {
                            this.state.dataForm ?
                                this.preloader() :
                                <input type="submit" value={this.translation['Deposit']} />
                        }
                    </div>
                </form>
            </div>
        )
    }

    depositFromAnotherDepository = item => {
        if (
            !this.state.tabState.deposit_from_another_depository ||
            item !== 'deposit_from_another_depository'
        )
            return null

        return (
            <div className="deposit_from_another_depository">
                <div className="deposit_from_another_depository_top">
                    <p>{this.translation['Send the address']}</p>
                </div>
                <div className="deposit_from_another_depository_middle">
                    <input value={this.props.data.address} readOnly />
                    <CopyToClipboard
                        text={this.props.data.address}
                        onCopy={this.copyAddress}
                    >
                        <span>{this.translation[this.state.textCopyBtn]}</span>
                    </CopyToClipboard>
                </div>
                <div className="deposit_from_another_depository_bottom">
                    <p>{this.translation['He or she needs']}</p>
                    <p>{this.translation['Transfers between depositories without commission']}</p>
                </div>
            </div>
        )
    }

    withdrawToMyWallet = item => {
        if (
            !this.state.tabState.withdraw_to_my_wallet ||
            item !== 'withdraw_to_my_wallet'
        )
            return null

        return (
            <div className="withdraw_to_my_wallet">
                <form
                    className="withdraw_to_my_wallet_form"
                    onSubmit={this.formSubmit}
                    data-active-form="withdraw"
                >
                    <div className="withdraw_to_my_wallet_form_transfer_amount">
                        <input
                            type="text"
                            placeholder="0,0"
                            required
                            name="amount"
                            value={this.state.value}
                            onChange={this.handleChange}
                            onBlur={this.checkTransactionValue}
                        />
                        <p>cpt</p>
                    </div>
                    <div className="withdraw_to_my_wallet_form_info_transaction">
                        <div>
                            <p>{this.translation['The cost per transaction']} {numberWithCommas(this.props.data.freeWithdrawCpt)} cpt</p>
                            <p className={`error ${!this.state.withdrawError ? 'hidden' : ''}`}>{this.translation['You don\'t have enough money to pay for this transaction.']}</p>
                        </div>
                        {
                            this.state.dataForm  ?
                                this.preloader() :
                                <input className="btn" type="submit" value={this.translation['Withdraw']} disabled/>
                        }
                    </div>
                </form>
            </div>
        )
    }

    sendToAnotherDepository = item => {
        if (
            !this.state.tabState.send_to_another_depository ||
            item !== 'send_to_another_depository'
        )
            return null

        return (
            <div className="send_to_another_depository">
                <form
                    className="send_to_another_depository_form"
                    onSubmit={this.formSubmit}
                    data-active-form="pay"
                >
                    <div className="send_to_another_depository_form_info_address">
                        <p>{this.translation['Depository address to transfer']}</p>
                    </div>
                    <div className="send_to_another_depository_form_wallet_address">
                        <input type="text" name="receiver" placeholder={this.translation['Wallet address']} />
                    </div>
                    <div className="send_to_another_depository_form_info_how_much">
                        <p>{this.translation['How much send']} cpt</p>
                    </div>
                    <div className="send_to_another_depository_form_transfer_amount">
                        <input
                            type="text"
                            placeholder="0,0"
                            required
                            name="amount"
                            value={this.state.value}
                            onChange={this.handleChange}
                        />
                        <p>cpt</p>
                    </div>
                    <div className="send_to_another_depository_form_info_commission">
                        <p>{this.translation['Transfers between depositories without commission']}</p>
                            {
                                this.state.dataForm  ?
                                    this.preloader() :
                                    <input type="submit" value={this.translation['Send']} />
                            }
                    </div>
                </form>
            </div>
        )
    }

    buyCPT = item => {
        if (!this.state.tabState.buy_CPT || item !== 'buy_CPT') return null

        return (
            <div className="buy_CPT">
                <form className="buy_CPT_form" onSubmit={this.formSubmit}>
                    <div className="buy_CPT_form_info_pay">
                        <p>Pay</p>
                    </div>
                    <div className="buy_CPT_form_deposit_amount">
                        <input
                            type="text"
                            placeholder="1000.0"
                            required
                            value={this.state.value}
                            onChange={this.handleChange}
                        />
                    </div>
                    <div className="buy_CPT_form_select">
                        <select>
                            <option>RUB</option>
                            <option>USD</option>
                            <option>EUR</option>
                        </select>
                    </div>
                    <div className="buy_CPT_form_info_get">
                        <p>Get</p>
                    </div>
                    <div className="buy_CPT_form_deposit_amount_CPT">
                        <input
                            type="text"
                            placeholder="23131,03 CPT"
                            readOnly
                        />
                    </div>
                    <div className="buy_CPT_form_buy">
                        <input type="submit" value="Buy by Card" />
                    </div>
                </form>
            </div>
        )
    }

    preloader = () => {
        return(
            <div className="preloader">
                <div></div>
                <div></div>
            </div>
        )
    }

    handleChange = event => {
        let string = event.target.value.replace(/[^0-9,.]/g, '')
        string = string.replace(/,/g, '.')
        string = string.replace(/^([^\.]*\.)|\./g, '$1')

        let correctedString = (+string)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')

        this.setState({
            value: string,
            correctedString,
        })
    }

    formSubmit = event => {
        event.preventDefault();
        let form = event.target;
        let dataForm = new FormData(form);
        this.setState({
            dataForm: dataForm,
            modalForm: this.modalForm[form.attributes.getNamedItem("data-active-form").value],
        })

        this.getStatus();
    }
}
